import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { BookAppointementService } from 'src/app/core/services/api-services/book-appointment.service';
@Component({
  selector: 'app-add-appointment-platform',
  templateUrl: './add-appointment-platform.component.html',
  styleUrls: ['./add-appointment-platform.component.scss'],
})
export class AddAppointmentPlatformComponent implements OnInit {
  AddappointmentForm: FormGroup | any;
  locationId: any;
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<AddAppointmentPlatformComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public toastrService: ToastrService,
    private appointmentService: BookAppointementService
  ) {
    this.locationId = this.data.location;
  }

  ngOnInit(): void {
    this.initializeNote();
  }

  initializeNote() {
    this.AddappointmentForm = this.fb.group({
      server_location: [this.locationId, Validators.required],
      name: ['', Validators.required],
    });
  }

  submitForm() {
    if (this.AddappointmentForm.valid) {
      const payload = this.AddappointmentForm.value;
      this.isLoading = true;
      // Call UserService method to add user insurance
      this.appointmentService.addAppointmentPlatform(payload).subscribe(
        (res: any) => {
          if (res?.body?.success) {
            this.toastrService.success(res?.body?.message);
            this.dialogRef.close(res?.body?.success);
            this.isLoading = false;
          }
        },
        (error: any) => {
          console.error('Error adding Appointment platform:', error);
          this.isLoading = false;
          // Handle error
        }
      );
    } else {
      Object.keys(this.AddappointmentForm.controls).forEach((field) => {
        const control = this.AddappointmentForm.get(field);
        control.markAsTouched({ onlySelf: true });
      });
      this.isLoading = false;
    }
  }
}
